import React, { useState, useEffect } from "react";
import '../styles/LearnerFeedback.css';
import FeedbackForm from "./FeedbackForm";
import dropdown_open from '../images/dropdown_open.png';
import dropdown_close from '../images/dropdown_close.png';
import { feedback, allYouTubeVideos } from '../Services/AllServices'; // Adjust the import path
import { getUserID } from '../Storage/Storage'; // Adjust the import path accordingly
import Popup from './pop_up'; // Import the Popup component

const LearnerFeedback = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [userId, setUserId] = useState("");
    const [feedbackDescription, setFeedbackDescription] = useState("");
    const [videoList, setVideoList] = useState([]);
    const [isPopupVisible, setIsPopupVisible] = useState(false); // State for controlling pop-up visibility

    useEffect(() => {
        const fetchVideos = async () => {
            const callback = (response) => {
                console.log('Approved Videos Response:', response);
                if (Array.isArray(response.data)) {
                    setVideoList(response.data);
                } else {
                    console.error('Data is not an array:', response);
                }
            };
            await allYouTubeVideos(callback);
        };

        const fetchUserId = async () => {
            const id = await getUserID();
            setUserId(id);
        };

        fetchVideos();
        fetchUserId();
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleOptionSelect = (video) => {
        setSelectedVideo(video);
        setSearchQuery(video.title);
        setIsDropdownOpen(false);
    };

    const filteredTitles = videoList.filter((video) =>
        video.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setSelectedVideo(null);
    };

    const handleFeedbackSubmit = async () => {
        const videoId = selectedVideo?._id;

        if (videoId && userId && feedbackDescription) {
            const formData = {
                userId,
                videoId,
                description: feedbackDescription
            };

            const callback = (response) => {
                console.log("Feedback Response:", response);
                setIsPopupVisible(true); // Show the success pop-up
                setFeedbackDescription(""); // Clear the feedback description after submission
            };

            await feedback(formData, callback);
        }
    };

    const handlePopupOk = () => {
        setIsPopupVisible(false);
        window.location.reload(); // Refresh the page when "OK" is clicked
    };

    return (
        <div className="feedback-container">
            <div className={`custom-select ${isDropdownOpen ? "open" : ""}`}>
                <div className="custom-select-header" onClick={toggleDropdown}>
                    <input
                        type="text"
                        placeholder="Search Video Title"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="search-input"
                        onFocus={toggleDropdown}
                    />
                    <span className="custom-select-arrow">
                        {isDropdownOpen ? (
                            <img src={dropdown_close} alt="dropdown open" className="dropdown-icon" />
                        ) : (
                            <img src={dropdown_open} alt="dropdown close" className="dropdown-icon" />
                        )}
                    </span>
                </div>

                {isDropdownOpen && (
                    <div className="custom-select-options">
                        {filteredTitles.length > 0 ? (
                            filteredTitles.map((video, index) => (
                                <div
                                    key={index}
                                    className="custom-select-option"
                                    onClick={() => handleOptionSelect(video)}
                                >
                                    {video.title}
                                </div>
                            ))
                        ) : (
                            <div className="no-options">No results found</div>
                        )}
                    </div>
                )}
            </div>

            {selectedVideo && (
                <>
                    <div className="feedback-video-item">
                        <div className="feedback-video-thumbnail">
                            <img src={selectedVideo.thumbnail.url} alt={`Thumbnail for ${selectedVideo.title}`} />
                        </div>
                    </div>

                    <div className="feedback-video">
                        <h4 className="feedback-video-title">{selectedVideo.title}</h4>
                        <div className="feedback-video-description">
                            {selectedVideo.description || "No description available"}
                        </div>
                    </div>
                </>
            )}

            <FeedbackForm
                feedbackDescription={feedbackDescription}
                setFeedbackDescription={setFeedbackDescription}
                handleFeedbackSubmit={handleFeedbackSubmit}
                disabled={!selectedVideo}
            />

            {/* Success Pop-up */}
            {isPopupVisible && (
                <Popup message="Form Submitted Successfully!" onConfirm={handlePopupOk} />
            )}
        </div>
    );
};

export default LearnerFeedback;
